import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Reviews from './components/Reviews';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center gap-3">
              <img 
                src="https://static.readdy.ai/image/6084b339fc3a78c83811e4e1149e506c/3564ec11419a91dc68d58bb73639f075.jpeg" 
                alt="ICM Logo" 
                className="h-12 w-12 object-contain"
              />
              <div>
                <h2 className="text-lg font-bold text-blue-900">ICM</h2>
                <p className="text-xs text-gray-600">Instituto de Clínica Médica</p>
              </div>
            </div>
            
            <div className="hidden md:flex items-center gap-8">
              <button onClick={() => scrollToSection('inicio')} className="text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">
                Inicio
              </button>
              <button onClick={() => scrollToSection('sobre-nosotros')} className="text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">
                Sobre Nosotros
              </button>
              <button onClick={() => scrollToSection('servicios')} className="text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">
                Especialidades Médicas
              </button>
              <button onClick={() => scrollToSection('opiniones')} className="text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">
                Opiniones
              </button>
              <button onClick={() => scrollToSection('contacto')} className="text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">
                Contacto
              </button>
            </div>

            <a 
              href="tel:+542234515475" 
              className="bg-blue-600 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Llamar para Turno
            </a>
          </div>
        </div>
      </nav>

      {/* Sections */}
      <div id="inicio">
        <Hero />
      </div>
      <div id="sobre-nosotros">
        <About />
      </div>
      <div id="servicios">
        <Services />
      </div>
      <div id="opiniones">
        <Reviews />
      </div>
      <div id="contacto">
        <Contact />
      </div>
      <Footer />
    </div>
  );
}